import StatEval from './stat-spy.js';

const DEFAULTS = {
  playbackEventType: 'Free',
  actions: {
    play: {
      event: 'clickPlay'
    },
    pause: {
      event: 'clickPause'
    },
    change_quality: {
      event: 'clickQualityItem'
    },
    video_click: {
      event: 'clickVideoArea'
    }
  },
  eventsInfo: {}
};

class StatGTM extends StatEval {
  constructor(player, options) {
    let options_ = Object.assign({}, DEFAULTS, options);

		let events = [];
		for (let i in options_.actions) {
			options_.actions[i].event && events.push(options_.actions[i].event);
		}
		options_.events = events;

    super(player, options_);
    this.events_ = {};
    this.actions = options_.actions;
    this.playbackEventType = options_.playbackEventType;
    this.eventsInfo = options_.eventsInfo;
    this.player = player;

    this.init();
  }

  init() {
		for (let i in this.actions) {
			let event = this.actions[i].event;
			this.events_[event] = this.events_[event] || [];
			this.events_[event].push(Object.assign({type: i}, this.actions[i]));
    }

    let video_el = this.player.el_.getElementsByTagName('video')[0];
    this.player.on(video_el, 'mousedown', (event) => {
      if (event.button === 0 && this.player.controls()) {
        this.trigger('clickVideoArea');
      }
    });
  }
  
  send(ev) {
    super.send(ev);
    if (this.player.vast && this.player.vast.isAdPlaying()) {
      return;
    }
    let event;
    if (ev == 'clickQualityItem') {
      event = 'VideoQualitySwitch';
    } else if (ev == 'clickVideoArea') {
      event = this.player.paused() && this.player.hasStarted() ? `Video${this.playbackEventType}Play` : `Video${this.playbackEventType}Pause`;
    } else {
      event = ev == 'clickPlay' ? `Video${this.playbackEventType}Play` : `Video${this.playbackEventType}Pause`;
    }
    window.dataLayer = window.dataLayer || [];
    let eventObject = Object.assign({}, {'event': event}, this.eventsInfo);
    for (let propery in eventObject) {
      if (!eventObject[propery]) {
        delete eventObject[propery];
      }
    }
    dataLayer.push(eventObject);
  }
}

export default StatGTM;
